export default (function (file) {
  return function (resolve) {
    require(["@/".concat(file)], resolve);
  };
});